module.exports = __webpack_public_path__ + "img/south-africa-logo-icon.c4487089.png";